import { URLS } from "@app/shared";
import { Link } from "@design-system/components";
import { getCurrentLocaleCode, trans } from "@mongez/localization";
import { ArrowRight } from "lucide-react";
import { toolLocales } from "../utils";

export function FinancialCalendar() {
  const locale = getCurrentLocaleCode();
  const { standard } = toolLocales(locale);

  return (
    <section
      aria-labelledby="financial-calendar-title"
      className="container pb-14 lg:pb-16"
    >
      <div className="flex flex-col gap-6">
        <h2
          id="financial-calendar-title"
          className="text-2xl font-bold text-marine sm:text-3xl"
        >
          {trans("financialCalendar")}
        </h2>

        <euroland-tool
          data-tool-name="FinCalendar2"
          data-tool-version="ticker"
          data-tool-language={standard}
        />
        <Link
          to={URLS.investor.financialCalendar}
          className="group mx-auto inline-flex w-fit items-center gap-2 rounded-full bg-steel px-5 py-3 text-sm font-bold uppercase tracking-wider text-white transition-colors duration-300 hover:bg-steel/80 sm:px-6 sm:py-3.5 sm:text-base"
        >
          {trans("viewAllEvents")}
          <ArrowRight
            className="h-4 w-4 shrink-0 transition-transform duration-300 group-hover:translate-x-0.5 rtl:rotate-180 rtl:group-hover:-translate-x-0.5"
            aria-hidden
          />
        </Link>
      </div>
    </section>
  );
}
